import { useParams } from "react-router-dom";
import { useLectures } from "../hooks/useLectures";
import Alerts from "../../../../components/Alerts";
import PageSkeleton from "./PageSkeleton";
import LectureItem from "./LectureItem";
import React, { useEffect } from "react";
import { useInView } from "react-intersection-observer";

function Lectures() {
    const { courseid } = useParams();
    // const [searchParams, setSearchParams] = useSearchParams();

    const filter = { field: "courseId", value: courseid };

    const include = [
        { field: "VideosDuration", value: "true" },
        { field: "VideosCount", value: "true" },
        { field: "QuizzesCount", value: "true" },
        { field: "StudentsCount", value: "true" },
        { field: "Discount", value: "true" },
        { field: "IsOwned", value: "true" },
    ];

    const includeFields = ["videosCount", "quizzesCount", "studentsCount"];

    const perPage = 4;

    const {
        isPending,
        lectures,
        fetchNextPage,
        hasNextPage,
        isFetchingNextPage,
    } = useLectures({
        filter,
        include,
        includeFields,
        perPage,
        courseid,
    });

    const { ref, inView } = useInView();

    useEffect(() => {
        if (inView && hasNextPage) {
            fetchNextPage();
        }
    }, [inView, hasNextPage, fetchNextPage]);

    const noLectures = !lectures?.pages?.[0]?.data?.length && !isPending;

    return (
        <section className="py-6">
            {isPending && <PageSkeleton />}
            {noLectures ? (
                <Alerts
                    variant={"filled"}
                    severity={"error"}
                    message={"هذه الكورس لا تحتوي علي محاضرات حتي الأن"}
                />
            ) : (
                lectures?.pages?.map((lectures, i) => (
                    <React.Fragment key={i}>
                        {lectures?.data?.map((lecture, i) => {
                            if (lectures.data.length == i) {
                                return (
                                    <LectureItem
                                        lecture={lecture}
                                        key={lecture.id}
                                    />
                                );
                            }
                            return (
                                <LectureItem
                                    innerRef={ref}
                                    lecture={lecture}
                                    key={lecture.id}
                                />
                            );
                        })}
                        {/* <Loader /> */}
                    </React.Fragment>
                ))
            )}
            {!noLectures && (
                <div>
                    {isFetchingNextPage ? (
                        <PageSkeleton />
                    ) : (
                        // <div className="flex items-center justify-center py-4">
                        // </div>
                        !hasNextPage && (
                            <p className="p-4 font-semibold text-gray-500 text-md">
                                لا توجد محاضرات اخري
                            </p>
                        )
                    )}
                </div>
            )}
        </section>
    );
}

export default Lectures;
